// extracted by mini-css-extract-plugin
export var title = "CVRow-module--title--1_FcB";
export var link = "CVRow-module--link--1df48";
export var years = "CVRow-module--years--1fYFn";
export var location = "CVRow-module--location--2-JZK";
export var description = "CVRow-module--description--Gn2fC";
export var fadeIn = "CVRow-module--fadeIn--1i4fj";
export var slideIn = "CVRow-module--slideIn--JLagA";
export var bgGradient = "CVRow-module--bgGradient--1_tI0";
export var borderColorStep = "CVRow-module--borderColorStep---3c03";